import dayjs from 'dayjs'
const labelCenterStyle = {
  style: {
    'task-list-header-label': {
      'text-align': 'center',
      width: '100%',
    },
  },
}
const centerStyle = {
  style: {
    'task-list-header-label': {
      'text-align': 'center',
      width: '100%',
    },
    'task-list-item-value-container': {
      'text-align': 'center',
      width: '100%',
    },
  },
}
const columns = [
  {
    label: '#',
    value: 'seq',
    width: 40,
    center: true,
  },
  {
    label: '订单计划',
    value: 'planName',
    width: 200,
    expander: true,
    headerCenter: true,
    html: true,
    // events: {
    //   click(e) {
    //     console.log('click --->', e)
    //   },
    // },
  },
  {
    label: '计划开始日期',
    value: ({ start }) => {
      return dayjs(start).format('YYYY-MM-DD')
    },
    width: 120,
    center: true,
  },
  {
    label: '计划结束日期',
    value: ({ start, duration }) => {
      return dayjs(start + duration).format('YYYY-MM-DD')
    },
    width: 120,
    center: true,
  },
  {
    label: '计划总产量',
    value: 'planTotalQty',
    width: 120,
    center: true,
  },
  {
    label: '已排产总数',
    value: 'planFinishQty',
    width: 120,
    center: true,
  },
  {
    label: '进度',
    value: ({ percent }) => {
      return `${percent || 0}%`
    },
    width: 100,
    center: true,
  },
]

export default () => {
  return {
    taskMapping: {
      progress: 'percent',
    },
    maxRows: 100,
    maxHeight: 500,
    row: {
      height: 30,
    },
    calendar: {
      hour: {
        display: true,
      },
    },
    chart: {
      progress: {
        bar: false,
      },
      expander: {
        display: true,
      },
    },
    taskList: {
      expander: {
        straight: false,
      },
      columns: columns.map((col) => {
        if (col.center) return { ...col, ...centerStyle }
        if (col.headerCenter) return { ...col, ...labelCenterStyle }
        return col
      }),
    },
    locale: {
      weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      months: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],
    },
  }
}
